export const formatFeedbackData = (feedbackData = []) => {
  const transformedData =
    feedbackData &&
    feedbackData.map((review) => {
      return {
        author: review?.display_name,
        description: review?.comment,
        ratingValue: review?.rating,
      };
    });
  return transformedData?.slice(0, 5) || [];
};
